import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import AttendanceLessonTime from './AttendanceLessonTime'
import AttendanceStatus from './AttendanceStatus'
import AttendTime from './AttendTime'
import {fetchAttendance, setTotalSalary, resetTotalSalary} from './ducks'
import FilterBy from 'template/FilterBy';
import {alert} from 'util/alert';
import SalaryModal from 'template/Modals/Salary';
import ExportModal from 'template/Modals/Export';
import { RESET_SALARY, SET_SALARY } from './ducks';
import __R, { userCan } from 'containers/__R'
import SalaryCalculator from 'components/Form/Fields/SalaryCalculator'
import { MenuItem, Dropdown } from 'react-bootstrap'

import './attendance.scss'
import {
	PanelWrapper,
	Tab,
	Tabs,
  Table,
} from 'components/UI'

const FILTER_OPTIONS = {
  attendanceClass: {
    selectMultiple: true,
  },
	attendanceStatus:{
		selectMultiple: false,
	}
}

const mapStateToProps = (state) => ({
	attendance: state.getAttendance
})

const mapDispatchToProps = dispatch => {
  return {
    fetchAttendance: (schoolId, state, attendanceInfo, callback) => dispatch(fetchAttendance(schoolId, state, attendanceInfo, callback)),
    setTotalSalary: (salary)=> dispatch(setTotalSalary(salary)),
    resetTotalSalary: ()=> dispatch(resetTotalSalary())
  };
};

momentDurationFormatSetup(moment)

class Attendance extends React.Component {
	constructor(props) {
    super(props)
    this.state = {
      attendanceInfo: {
        start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        class_id_list: '',
        state: '',
      },
      filterData: {
        daterange: {}
      },
      filterTypes: ['daterange', 'attendanceClass', 'attendanceStatus'],
      totalSalary: 0
    }

    this.onFilterChange = this.onFilterChange.bind(this)
		this.onPageChange = this.onPageChange.bind(this)
		this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this)
		this.fetchAttendanceList = this.fetchAttendanceList.bind(this)
	}

  componentWillMount() {
    this.fetchAttendanceList(1)
	}

  downloadCheckinRecord(format) {
    ExportModal({
      type: 'attendance',
      format: format,
      totalSalary: this.state.totalSalary,
      attendance: this.props.attendance,
      attendanceInfo: this.state.attendanceInfo,
      id: this.props.state === 'teacher'? this.props.teacherId : this.props.studentId,
      state: this.props.state,
      title: this.props.state === 'teacher'? 'Export Teacher Attendance': 'Export Student Attendance'
    });
  }

	fetchAttendanceList(newPageNumber, newAmountPerPage){
		const {dispatch, params, state, studentId, attendance, teacherId} = this.props
		const {activePage, itemsCountPerPage} = attendance.pagination;

		if(state == 'student'){
			this.props.fetchAttendance(studentId, state, {
				...this.state.attendanceInfo,
				amount_per_page: newAmountPerPage || itemsCountPerPage,
				current_page_number: newPageNumber
			})
		} else if (state == 'teacher') {
			this.props.fetchAttendance(teacherId, state, {
				...this.state.attendanceInfo,
				amount_per_page: newAmountPerPage || itemsCountPerPage,
				current_page_number: newPageNumber
			})
		}
	}

  onFilterChange(change){
		const {filterData, lastFilterReset, justReset, lastFilterChanged} = change
    const {dispatch, params, state, studentId, teacherId} = this.props

    let attendanceInfo = {...this.state.attendanceInfo}

    let newArr = []
    if(filterData.attendanceClass){
      filterData.attendanceClass.items.map((c) => {
        newArr.push(c.ctClass || c.classID)
      })
    }

    attendanceInfo.class_id_list = newArr
    attendanceInfo.amount_per_page = 10
    attendanceInfo.current_page_number = 1
    
    if((filterData.daterange.startDate && !filterData.daterange.endDate) || (!filterData.daterange.startDate && filterData.daterange.endDate)){
      return
    } 

    if(filterData.daterange){
      if(filterData.daterange.endDate && filterData.daterange.startDate){
        attendanceInfo.start_date = moment(filterData.daterange.startDate).format('YYYY-MM-DD');
        attendanceInfo.end_date = moment(filterData.daterange.endDate).format('YYYY-MM-DD');
      }
    }

		if(filterData.attendanceStatus){
			attendanceInfo.state = filterData.attendanceStatus.items[0].value
		}

    let Id = ''
    if(state == 'student'){
      Id = studentId
    } else if (state == 'teacher'){
      Id = teacherId
    }

		if(lastFilterReset == 'attendanceStatus' && justReset == true){
			delete attendanceInfo.state
		}

		if(lastFilterChanged == 'daterange' && filterData.daterange.endDate == null && filterData.daterange.startDate == null){
			this.setState({
				attendanceInfo: {
					...this.state.attendanceInfo,
					start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
					end_date: moment().format('YYYY-MM-DD'),
				}
      }, () => {
				this.fetchAttendanceList(1)
			})
		}else if(moment(attendanceInfo.end_date).diff(moment(attendanceInfo.start_date), 'months')>=3) {
      return alert.warning(__('Only search within three months period', 'teacherAttendance'))
    }else {
      this.setState({attendanceInfo}, () => {
        this.props.fetchAttendance(Id, state, {
          ...this.state.attendanceInfo,
          amount_per_page: 10,
          current_page_number: 1
        }, ()=>{
          if(this.props.attendance.result == 'failure' && this.props.attendance.reason == 'can not filter records more than 3 months'){
            alert.warning(__('Only search within three months period', 'teacherAttendance'))
            .then(() => {})
          }
        })
      })  
    }

    this.setState({filterData})
  }

	onPageChange(activePage){
		if (activePage == this.props.attendance.pagination.activePage) {
      return;
    }

    this.fetchAttendanceList(activePage);
	}

	onItemsCountPerPageChange(itemsCountPerPage){
		this.fetchAttendanceList(1, itemsCountPerPage);
	}

  render() {
    const fields = [
      {
        name: 'class_name',
        title: __('Class Name', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        }
      },
      {
        name: 'lesson_index',
        title: __('Lesson', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "8%"
            }
          }
        },
        getTdContent: ({ trData })=>{
          return __('Lesson', 'teacherAttendance')+' '+trData.lesson_index;
        },
      },
      {
        name: 'lesson_time',
        title: __('Lesson Time', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "20%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendanceLessonTime attendenceInfo={attendenceInfo} />
        },
      },
      {
        name: 'check_in_datetime',
        title: __('Attend Time', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "15%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendTime attendenceInfo={attendenceInfo} />
        },
      },
      {
        name: 'state',
        title: __('Status', 'teacherAttendance'),
        getTdProps: ({tbodyData})=>{
          return {
            style: {
              width: "7%"
            }
          }
        },
        getTdContent: ({ trData: attendenceInfo })=>{
          return <AttendanceStatus attendenceInfo={attendenceInfo} currentRole={this.props.state} />
        },
      },
    ]

    const schoolId = localStorage.getItem('schoolId')

    let returningPath = ''
    if(!this.props.location){
      returningPath = '/student'
    }else if(this.props.location.state != undefined){
      returningPath = this.props.location.state.returningPath
    }


    const {attendanceInfo, filterData} = this.state
    const {start_date, end_date} = attendanceInfo
    const daterangeOptions = {
      startDate: filterData.daterange.startDate || moment(start_date),
      endDate: filterData.daterange.endDate || moment(end_date),
      endDatePlaceholderText: __('Today', 'teacherAttendance')
    }

    const {attendance, state, params, studentId, studentName, teacherId, resetTotalSalary, setTotalSalary, teacherInfo} = this.props
    const {
      list = [],
      teacher_name,
      attended_count,
      attended_hour,
      absent_count,
      absent_hour,
      late_count,
      late_hour,
      unattended_count,
      unattended_hour,
      truancy_count,
      truancy_hour,
      normal_count,
      normal_hour,
      retroactive_count,
      unchecked_count,
      unchecked_hour,
			pagination,
    } = attendance

    return (
      <div className={state == 'teacher' ? 'teacher-attendance-table-container' : 'student-attendance-table-container'}  >

        {/* {state == 'teacher' &&  <div>{__('Teacher / {teacher}', 'teacherAttendance', {teacher: teacher_name})}</div>} */}

        {
					returningPath != '/student' &&
					// temporary solution to redirect to deleted teacher tab
          <Link className='teacher_attendance-close pull-right' to='/teacher'>
    				<i className='fa icon-cancel'></i>
	  			</Link>
				}
        <div className='attendance-title'>
          <div>
            {__('Attendance Record', 'teacherAttendance')}
          </div>
        </div>
        <__R can={state == 'teacher' ? 'view_teacher_check_in_record' : "view_student_check_in_record"} by='disable'>
            <Dropdown  id='setting-dropdown' >
              <Dropdown.Toggle className='expand-to-right expand-to-down'>
                {__('Export Record', 'teacherAttendance')}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <MenuItem eventKey="export-student" onSelect={()=>this.downloadCheckinRecord('excel')} disabled={list.length===0}>{__('Export Record to Excel', 'teacherAttendance')}</MenuItem>
                <MenuItem eventKey="export-student" onSelect={()=>this.downloadCheckinRecord('csv')} disabled={list && list.length===0}>{__('Export Record to CSV', 'teacherAttendance')}</MenuItem>
              </Dropdown.Menu>
            </Dropdown>
        </__R>

        <FilterBy
          filterData={this.state.filterData}
          selectMultiple={true}
          filters={this.state.filterTypes}
          options={{...FILTER_OPTIONS, daterange: daterangeOptions, Id: teacherId ? teacherId : studentId, state: state}}
          schoolId={schoolId}
          onChange={this.onFilterChange}
        />

        <div className='container-fluid'>
          <div className='sections section-1'>
            <div className='row'>
              <div className='col-xs-6'>
                <div className='section-label'>{__('Total Attended Count/Duration: {count}', 'teacherAttendance', {count: attended_count})}</div>
                <div className='section-content'>{moment.duration(Number(attended_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'}</div>
              </div>
              <div className='col-xs-6'>
                <div className='section-info-1'>
                  {__('On Time Count/Duration: {count} / {hour}',
                  'teacherAttendance',
                  {count: normal_count, hour: moment.duration(Number(normal_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'})}
                </div>
                <div className='section-info-1'>
                  {__('Late Count/Duration: {count} / {hour}',
                  'teacherAttendance',
                  {count: late_count, hour: moment.duration(Number(late_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'})}
                </div>
                <div className='section-info-1'>
                  {__('Makeup Count: {count}','teacherAttendance', {count: retroactive_count})}
                </div>
              </div>
            </div>
          </div>
          <div className='sections section-2'>
            <div className='row'>
              <div className='col-xs-6'>
                <div className='section-label'>{__('Total Unattended Count/Duration: {count}', 'teacherAttendance', {count: unattended_count})}</div>
                <div className='section-content'>{moment.duration(Number(unattended_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'}</div>
              </div>
              <div className='col-xs-6'>
                <div className='section-info-2'>
                  {__('Absent (with excuse) Count/Duration: {count} / {hour}',
                  'teacherAttendance',
                  {count: absent_count, hour: moment.duration(Number(absent_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'})}
                </div>
                <div className='section-info-2'>
                  {__('Absent (without notice) Count/Duration: {count} / {hour}',
                  'teacherAttendance',
                  {count: truancy_count, hour: moment.duration(Number(truancy_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'})}
                </div>
              </div>
            </div>
          </div>
          {
            state === 'student' && 
            <div  className='sections section-3'>
              <div className='section-info-2'>
                <div>{__('Unchecked Count: {count}', 'teacherAttendance', {count: unchecked_count})}</div>
              </div>
              <div className='section-info-2'>
                <div>{__('Unchecked Duration: {hour}', 'teacherAttendance', {hour: moment.duration(Number(unchecked_hour), 'minutes').format('h[h] m[m]', {trim: 'all'}) || '0h'})}</div>
              </div>
            </div>
          }
        </div>
        {state === 'teacher' && <SalaryCalculator teacherInfo={teacherInfo} attendance={attendance} setTotalSalary={setTotalSalary} resetTotalSalary={resetTotalSalary} salaryCalculatorType='checkin' />}
        <table style={{width: '100%'}}>
          <tbody>
              <td>
                <Table
                  data={list}
                  fields={fields}
                  crqassName='registration-table'
                  settingThTitle={__('Settings', 'class')}
                  settingWidth={'150px'}
                  useMultiSelection={false}
                  oneSettingPerRow={false}
                  dropdownGuideWidth={160}
                  dropdownGuideHeight={228}
                  pagination={pagination}
                  usePagination={true}
                  onPageChange={this.onPageChange}
                  onItemsCountPerPageChange={this.onItemsCountPerPageChange}
                />
              </td>
            </tbody>
        </table>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Attendance)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/Attendance.js